import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  Type,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { v4 as uuidv4 } from 'uuid';
import { ColPropConfig, Notify } from 'dg-dynamic-grid-lib';
import { SampleDialogComponent } from '../../../dg_components_test/dg-dynamic-grid-test/dg-dynamic-grid-test.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { CommonService } from '../service/common.service';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { AppGenFormbuilderService } from '../../app-gen-formBuilder/service/app-gen-formbuilder.service';
import { getFilteredPostData } from 'src/app/digigov/dg_components/dg-questionnaire/dg-questionnaire.utils';
import { DatePipe, formatDate } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ExecutionService } from '../service/execution.service';
import { AppGenServiceService } from '../service/app-gen-service.service';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { InputType } from 'dg-input-lib';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DgFileUploadComponent } from 'dg-file-upload-lib';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss'],
})
export class CommonComponent implements OnInit, OnChanges, AfterContentInit {
  colPropConfig: ColPropConfig = {
    idProp: 'columnId',
    nameProp: 'columnName',
    typeProp: 'type',
    comboProp: 'comboItems',
    pipeProp: 'pipe',
    validationsProp: 'validations',
    renderPathProp: 'renderPath',
    renderFunctionProp: 'renderFunction',
    appliedFilterProp: 'appliedFilter',
    isLegendProp: 'isLegend',
    colPinProp: 'colPinProp',
    hintProp: 'hint',
    disabledProp: 'disabled',
    readOnlyProp: 'readOnly',
  };
  mycontent: string;
  demoFormId: any;
  demoTid: any;
  @Input() res: any;
  @Input() formId;
  @Input() tid;
  @Output() emitTransId = new EventEmitter<number>();
  @Output() appGenDataEmit = new EventEmitter<any>();
  @Output() customCompData = new EventEmitter<any>();
  @Output('output') output = new EventEmitter<any>();

  // employee search start

  empConfig = {
    multiSelect: false,
    btnText: 'Add',
    header: 'Employee Search',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };

  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'true',
    multiselect: false,
    header: 'Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };

  showReadOnly = false;
  selectedEmployees: any;
  empName = '';
  emplocation = '';
  empdesignation = '';
  empdistrict = '';
  empgpf_number = '';
  employeeLoadId: any;
  attachData: any;

  comboColumns = [];
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  selectedComboValue: any = [];
  options: any = [];
  autocompleteControl = new FormControl();
  datePickerControl = new FormControl(null, [Validators.required]);
  timePickerControl = new FormControl(null, [Validators.required]);

  filteredOptions: any[];
  parentEvent = new Subject<any>();
  @ViewChild('dateFormat') dateFormat = new ElementRef('');
  @ViewChild('appgenFileUpload') appgenFileUpload: DgFileUploadComponent;
  @ViewChild('emp') emp: DgEmployeeSearchComponent;
  editorConfig: any = {
    editorplaceholder: 'Type your text here… ',
    toolbar: [
      ['Source'],
      ['Image'],
      ['Bold', 'Italic', 'Underline', 'Link'],
      ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'Justify'],
      ['BulletedList', 'NumberedList'],
      ['TextColor', 'BGColor'],
      ['Anchor'],
      ['Table'],
      ['Subscript', 'Superscript'],
      ['Cut', 'Copy', 'Paste'],
      ['Undo', 'Redo', 'Maximize'],
      ['Print'],
      ['Styles', 'Format', 'Font', 'FontSize'],
    ],
    extraPlugins: 'colorbutton',
    removePlugins: 'scayt',
    disableNativeSpellChecker: false,
    removeButtons: 'SCAYT',
  };

  gridConfig2 = {
    id: 'docNo', //to uniquely identify rows for selecting values
    showSearch: true,
    showColoredRowText: false,
    showLegend: true,
    showAdvanceFilterOptions: true,
    pageSize: 6,
    isRowSelectable: true, //changed from showcheckbox
    allowMultiRowSelection: true, //chagned from singleSelectionAllowed
    linkColumns: [{ attributeNameToShowLink: 'docNo' }], // changed from gridLinkVOLst
    legends: [
      {
        attributeName: 'previouslySeenFlag',
        color: 'violet',
        legendName: 'Previously Seen',
      },
      { attributeName: 'readFlag', color: 'red', legendName: 'New' },
    ], //chagned from GridAttributeColorMpgVOn
    columnHeaders: [
      { attributeName: 'fromOrToName', columnCaption: 'From' },
      { attributeName: 'description', columnCaption: 'Description' },
      { attributeName: 'sentOrRcvdDate', columnCaption: 'Received Date' },
      { attributeName: 'sentFromDept', columnCaption: 'Organization' },
      /* {
        attributeName: 'additionalAttribute1',
        columnCaption: 'Additional Attribute',
      }, */
      {
        attributeName: 'applicationStatus',
        columnCaption: 'Application Status',
      },
    ], // gridAttributeColumnHeaderMpgVOLst
    showColumnsWithWidth: [
      { name: 'docNo', width: 180 },
      { name: 'description', width: 180 },
      { name: 'subject', width: 100 }, ////prev width 180
      { name: 'fromOrToName', width: 120 },
      { name: 'sentOrRcvdDate', width: 120 },
      { name: 'sentFromDept', width: 75 }, //prev width 100

      //New Col added
      { name: 'applicationStatus', width: 105 },
      //{ name: 'priority', width: 100 },
    ],
    externalPaging: true,
    gridDataService: {
      url: '/worklist/inbox-files',
      method: 'post',
      input: {
        startPage: '1',
      },
    },
    showExportIcon: true,
    showPrintIcon: true,
    dgGridView: {
      showGridView: true,
      showCardView: true,
      showMailView: true,
    },
    activePage: 1,
    totalRows: 35,
    cargGridVo: {
      cardGridConfig: {
        pageSize: 6,
        externalPagination: true,
      },
    },
    mailViewVo: {
      selectedCardColorCss: 'selectedCard',
      unSelectedCardColorCss: 'unSelectedCard',
    },
  };

  colAr = {};
  roAr = {};
  addRowDeleteArray = [];
  addRowDelete = [];
  columnData: any = [];

  //dg-tree
  dgAppTreeJ = {};
  nodeDataUrl = {};
  nodeInsertUrl = {};
  //dg-listbox
  dataSourceJ = {};
  dgListBoxJ = {};
  dgListBoxPrKey = {};
  questionnaireData: any;
  loadComboTask: any = [];
  MultiselectValue: any;
  dropdownValue: any;
  demoComponent: any;
  buttonSubmit: boolean = false;
  dataTableFieldId: any;
  CKEDITOR: any;
  displayDevForm = {};
  flagDeveloperForm = false;
  toggleValue?: string;
  minDate: any;
  maxDate: any;
  addressData: any;
  currentDeleteJson: any[];
  deleteDataWithoutId: boolean;
  masterCount = 2;
  labelDefault: any;
  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private appGenServiceService: AppGenServiceService,
    public commonService: CommonService,
    private execution: ExecutionService,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private appGenFormbuilderService: AppGenFormbuilderService,
    public datePipe: DatePipe,
    private msgDsplyService: MessageDisplayService,
    private elementRef: ElementRef
  ) {}
  ngAfterContentInit(): void {
    if (this.execution.parentCommonService) {
      let formObj = {
        ...this.appGenServiceService.getAppGenData(this.formId, this.tid),
      };
      this.getKeys(formObj).forEach((index) => {
        if (this.commonService.componentMap[index] == 0 && formObj[index]) {
          formObj[index] = this.datePipe.transform(
            new Date(formObj[index]),
            'yyyy-MM-dd'
          );
        }
      });
      this.execution.parentCommonService?.notifyParentCommonServiceSubject?.next(
        {
          data: formObj,
          fieldId: this.res.fieldId,
          resultObj: formObj[this.res.fieldId], //this.commonService?.inputJsonData,
        }
      );
    }
  }
  isVisible(): boolean {
    const element = this.elementRef.nativeElement;
    return element.offsetParent !== null;
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  ngOnChanges(changes: SimpleChanges): void {
    /* if (this.execution.parentCommonService){
      this.execution.parentCommonService?.notifyParentCommonServiceSubject?.next({
        data: this.appGenServiceService.getAppGenData(this.formId, this.tid),
        fieldId: this.res.fieldId,
        resultObj: this.commonService?.inputJsonData,
      });
  } */
  }

  ngAfterViewInit() {}
  ngOnInit(): void {
    // if (this.res.fieldType == 108) {
    //   console.log('devform');
    // }
    /// this.commonService?.appGenFormGroup?.addControl('', this.datePickerControl);
    this.dataTableFieldId = this.res.fieldId;
    this.res.attribute.attachId = this.res.defaultValue;
    this.execution.notifySaveComponentResponse.subscribe((keyFieldId) => {
      this.masterUpdate();
      this.updateRows(keyFieldId);
    });
    if (this.res.fieldType == 90) {
      this.mycontent = this.res.defaultValue ? this.res.defaultValue : '';
      this.appGenServiceService.setAppGenData(this.res.fieldId, this.mycontent);
      this.commonService.appGenFormGroup.controls[this.res.fieldId]?.setValue(
        this.mycontent
      );
    }
    if (this.res.fieldType == 40) {
      let toggleDefault = this.res?.attribute?.defaultValue;
      let toggleData;

      if (toggleDefault) {
        if (this.res?.attribute?.comboMap) {
          let comboVal = this.res?.attribute?.comboMap;
          this.appGenServiceService
            .getComboIds(comboVal.toString())
            .subscribe((response: any) => {
              this.options = response;

              toggleData = this.options.filter(
                (data) => data.optionText == toggleDefault
              );
              this.toggleValue = toggleData[0].optionText;
            });
        }
      }
    }

    if (this.res.fieldType == 111) {
      // employee load condition
      this.employeeLoadId = this.res?.attribute?.defaultValue;
      if (this.employeeLoadId) {
        this.getViewEmployee(this.employeeLoadId);
      }
      console.log('employee', this.emp);
      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        //if condition reset -> make reset key
        // typescript -> reset form group k andr
        if (data == 'reset') {
          let selectedEmployees = [];
          this.emp.handleResult(selectedEmployees);
        }
        this.attachData = data;
      });
    }

    if (this.res.fieldType == 24) {
      // set deafult label value
      this.labelDefault = this.res?.attribute?.defaultValue;
      if (this.labelDefault) {
        this.res.lbl = this.labelDefault;
      }
      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        this.res.lbl = data;
      });
    }

    if (this.res.fieldType == 51) {
      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        if (data) {
          this.addressData = data;
        } else {
          this.addressData = this.res.addressFieldVOList;
        }
      });
    }

    if (this.res.fieldType == 12) {
      this.columnData = this.res?.children;
      this.columnData = this.columnData.map((c) => {
        c.children[0]?.attribute?.validations?.forEach((comp) => {
          let currentDate = new Date();

          if (
            comp.validationId != 9 &&
            comp.validationId != 10 &&
            comp.validationId != 11 &&
            comp.validationId != 12
          ) {
            this.commonService.dateValidation(
              comp.validationId,
              comp.cmpFormId,
              comp.otherCmpFormId,
              c.children,
              true
            );
          }
        });

        let obj;

        obj = {
          columnId: c.children[0]?.id,
          columnName: c.children[0]?.lbl,
          // displayable: c?.children[0].attribute?.isVisible
          //   ? c?.children[0].attribute?.isVisible
          //   : 1,
          isLink: c.children[0]?.fieldType == 23 ? true : false,
          displayable: true,
          disabled: c.attribute?.enableDisable,
          // type: c.children[0].fieldType == 96 ? null : c.children[0].fieldType,
          type: c.attribute?.hideShow
            ? 11
            : c.children[0]?.fieldType == 23
            ? null
            : c.children[0]?.fieldType,
          comboItems: [],
          defaultValue:
            c.children[0]?.fieldType == 23 ? c.children[0]?.lbl : '',
          //comboItems: c.children[0]?.attribute?.comboMap,
          // hint: !c.children[0]?.attribute?.isMandatory
          //   ? 'This field  is required'
          //   : '',
          validations: c.children[0]?.attribute?.isMandatory
            ? [
                {
                  async: false,
                  errorMessage:
                    c.children[0]?.attribute?.label + ` is required.`,
                  type: 'required',
                  value: null,
                  id: 0,
                },
                {
                  id: 0,
                  async: false,
                  type: 'maxLength',
                  value: c.children[0]?.attribute?.maxLength,
                  errorMessage:
                    'Max Length should be ' +
                    parseInt(c.children[0]?.attribute?.maxLength),
                },
                {
                  id: 0,
                  async: false,
                  type: 'minLength',
                  value: c.children[0]?.attribute?.minLength,
                  errorMessage:
                    'Min Length should be ' +
                    parseInt(c.children[0]?.attribute?.minLength),
                },
                {
                  type: 'date',
                  async: false,
                  id: 1234,
                  value: this.commonService.dateValue,
                  errorMessage: 'Please enter date in correct format.',
                },
              ]
            : [
                {
                  id: 0,
                  async: false,
                  type: 'maxLength',
                  value: c.children[0]?.attribute?.maxLength,
                  errorMessage:
                    'Max Length should be ' +
                    parseInt(c.children[0]?.attribute?.maxLength),
                },
                {
                  id: 0,
                  async: false,
                  type: 'minLength',
                  value: c.children[0]?.attribute?.minLength,
                  errorMessage:
                    'Min Length should be ' +
                    parseInt(c.children[0]?.attribute?.minLength),
                },
                {
                  type: 'date',
                  async: false,
                  id: 1234,
                  value: this.commonService.dateValue,
                  errorMessage: 'Please enter date in correct format.',
                },
              ],

          ...c.children[0],
        };

        return obj;
      });

      this.columnData.forEach((obj) => {
        if (obj?.type == 11) {
          obj.displayable = 0;
        }
        if (obj?.attribute?.comboMap) {
          this.comboColumns.push(obj.columnId);

          let comboString = obj?.attribute?.comboConfigurationString;
          if (
            comboString &&
            obj?.attribute?.comboConfigurationString != null &&
            obj?.attribute?.comboConfigurationString != '' &&
            obj?.attribute?.comboConfigurationString &&
            obj?.attribute?.comboConfigurationString != '{}' &&
            obj?.attribute?.comboConfigurationString != '""' &&
            JSON.stringify(comboString) != '{}' &&
            comboString != '""'
          ) {
            let tempComboConfigurationString = Object.assign({}, comboString);
            let flag = false;
            let comboStringVal = {};
            for (let key in tempComboConfigurationString) {
              let tempString: string = tempComboConfigurationString[key];
              tempString = Number(tempString)
                ? tempString.toString()
                : tempString;
              if (tempString.includes('ComponentId')) {
                let parentId = tempComboConfigurationString[key].split('_')[1];
                let fieldType = this.commonService.componentMap[parentId];
                let objValue = null;
                if (fieldType == 5) {
                  objValue = this.commonService.appGenFormGroup.controls[
                    parentId
                  ]?.value?.optionValue;
                } else {
                  objValue = this.commonService.appGenFormGroup.controls[
                    parentId
                  ]?.value;
                }
                comboStringVal[key] = objValue;
                flag = true;
              } else {
                comboStringVal[key] = tempString;
              }
            }

            if (comboStringVal && JSON.stringify(comboStringVal) != '{}') {
              this.loadComboTask.push(
                this.appGenServiceService.getComboIds(
                  obj?.attribute?.comboMap?.toString(),
                  comboStringVal
                )
              );
            }
          } else {
            // this.loadComboTask.push(
            //   this.appGenServiceService.getComboIds(
            //     obj?.attribute?.comboMap?.toString()
            //   )
            // );
          }
        }
        if (obj?.type == InputType.DATE || obj?.type === InputType.DATE_RANGE) {
          obj['pipe'] = {
            instance: this.datePipe,
            parameters: ['dd/MM/yyyy'],
          };
        }
      });
      let colData = {
        columnName: 'Actions',
        columnId: 'actions',
        width: 110,
        type: null,
        icons: true,
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        displayable: true,
        actionConfig: [
          {
            actionName: 'save',
            actionIcon: 'save',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: this.commonService.isReadOnly ? false : true,
            isDisabled: false,
          },
          ,
          // {
          //   actionName: 'up',
          //   actionIcon: 'arrow_upward',
          //   isVisible: true,
          //   isDisabled: false,
          // },
          // {
          //   actionName: 'down',
          //   actionIcon: 'arrow_downward',
          //   isVisible: true,
          //   isDisabled: false,
          // },
          {
            actionName: 'clear',
            actionIcon: 'cached',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'close',
            actionIcon: 'close',
            isVisible: false,
            isDisabled: false,
          },
        ],
      };
      if (this.res?.attribute?.showDelete) {
        colData?.actionConfig?.push({
          actionName: 'delete',
          actionIcon: 'delete',
          isVisible: this.commonService.isReadOnly ? false : true,
          isDisabled: false,
        });
      }
      this.columnData.push(colData);
      this.colAr[this.res.fieldId] = this.columnData;
      this.commonService.dataTableRowData = this.roAr;

      this.commonService.appGenFormGroup.controls[this.res.fieldId].setValue(
        this.columnData
      );

      // if (this.loadComboTask?.length != 0) {
      try {
        // forkJoin(this.loadComboTask).subscribe((response: any) => {
        //   let i = 0;
        this.colAr[this.res.fieldId].forEach((col) => {
          if (col?.attribute?.comboMap) {
            col.comboItems = col?.attribute?.comboMapValues;
          }
        });
        this.colAr[this.res.fieldId] = this.colAr[this.res.fieldId]?.toString()
          ? [...this.colAr[this.res.fieldId]]
          : [];
        this.setSubFieldData();
        // });
      } catch (error) {}
      // } else {
      //   this.setSubFieldData();
      // }

      this.roAr[this.res?.fieldId]?.map((x) => {
        x.uniqueKey = uuidv4();
      });

      // control.cmnSubFieldDtlsBeanList.forEach((element) => {
      //   this.subfieldMappingMap[element.id] = element.fldSubFldMpgId;
      // });
      // console.log('field sub Mapping Id', this.subfieldMappingMap);

      // console.log('primary key---', this.prKey);
      // console.log('primary key---', this.prKey[control.fieldId]);
    }
    if (this.res.fieldType == 108) {
      this.demoComponent = this.res?.attribute?.developerForm;
      this.demoFormId = this.res.attribute?.formName
        ? this.res.attribute?.formName.toString()
        : null;
      if (this.res?.attribute?.developerForm == 'Appgen form') {
        this.demoComponent = 'AppGenMainComponent';
      }
      //this.demoComponent = this
      this.displayDevForm[this.res?.attribute?.fieldId] = false; //!this.res?.attribute?.hideShow;
      if (this.execution.parentCommonService) {
        this.execution.parentCommonService?.notifyParentCommonServiceSubject?.next(
          {
            data: this.appGenServiceService.getAppGenData(
              this.formId,
              this.tid
            ),
            fieldId: this.res.fieldId,
            resultObj: this.commonService?.inputJsonData,
          }
        );
      }
      //this.demoTid = this.res.attribute?.formName?.transactionId.toString();
    }
    if (this.res.fieldType == 92) {
      let treeDataUrl: string = '';

      // let parentIdToSend = control.attribute.params[0].prntId;

      treeDataUrl = this.res?.attribute?.treeDataApiUrl;
      this.nodeDataUrl[this.res.fieldId] = this.res?.attribute?.nodeDataUrl;

      let pid = 45;
      this.nodeDataUrl[this.res.fieldId] =
        this.nodeDataUrl[this.res.fieldId] + pid;

      this.nodeInsertUrl[this.res.fieldId] = this.res?.attribute?.nodeInsertUrl;

      //s  let restemp: any
      this.http.get(treeDataUrl).subscribe((res) => {
        const restemp: any = res;
        this.dgAppTreeJ[this.res.fieldId] = restemp.data;
      });
    }

    if (this.res.fieldType == 87) {
      // group[control.fieldId] = new FormControl(control.defaultValue);

      // this.dgListBoxPrKey[control.fieldId] =
      //   control.attribute.primaryField;

      let url: string = '';
      let params = new HttpParams();

      let paramsData = [];

      paramsData = this.res.attribute.params;

      JSON.stringify(paramsData);

      let n = paramsData.length;

      for (let i = 0; i < n; i++) {
        params = params.append(
          '' + Object.keys(paramsData[i]),
          '' + Object.values(paramsData[i])
        );
      }
      // params = params.append("folderId", "0");
      // params = params.append("fromFolderflag", "0");

      url = this.res.attribute.url;

      this.http.get(url, { params: params }).subscribe((res) => {
        const restemp: any = res;
        this.dataSourceJ[this.res.fieldId] = restemp.data;
      });
    }

    if (this.res.fieldType == 71) {
      if (this.res?.attribute?.comboMap) {
        let comboVal = this.res?.attribute?.comboMap;
        // this.appGenServiceService
        //   .getComboIds(comboVal.toString())
        //   .subscribe((response: any) => {
        //     this.options = response;
        //     this.filteredOptions = this.autocompleteControl.valueChanges.pipe(
        //       startWith(''),
        //       map((value) => this._filter(value))
        //     );
        //   });
        this.filteredOptions = this.res?.attribute?.comboMapValues;
      }
    }
    if (this.res.fieldType == 79) {
      let currentDate = new Date();

      if (this.res?.attribute?.validations) {
        let valiID = this.res?.attribute?.validations[0]?.validationId;
        if (valiID == '5') {
          // Allow future Date
          this.minDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1)
          );
        } else if (valiID == '6') {
          // Allow today and future
          this.minDate = currentDate;
        } else if (valiID == '7') {
          // Allow past Date
          this.maxDate = new Date(
            currentDate.setDate(currentDate.getDate() - 1)
          );
        } else if (valiID == '8') {
          // Allow today and past
          this.maxDate = currentDate;
        }
      }

      this.datePickerControl.setValue(
        new Date(this.res?.attribute?.defaultValue)
      );

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        let latest_date = this.datePipe.transform(
          new Date(data),
          'yyyy-MM-dd HH:mm:ss'
        );

        this.datePickerControl.setValue(new Date(latest_date));
        this.appGenServiceService.setAppGenData(this.res.fieldId, latest_date);
      });
    }

    if (this.res.fieldType == 16) {
      this.timePickerControl.setValue(this.res?.defaultValue);

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        let latest_time = data;

        this.timePickerControl.setValue(latest_time);
        this.appGenServiceService.setAppGenData(this.res.fieldId, latest_time);
      });
    }
    if (this.res.fieldType == 81) {
      if (this.res?.attribute?.comboMap) {
        let comboVal = this.res?.attribute?.comboMap;
        if (
          this.res?.attribute?.comboConfigurationString != null &&
          this.res?.attribute?.comboConfigurationString != '' &&
          this.res?.attribute?.comboConfigurationString &&
          this.res?.attribute?.comboConfigurationString != '{}' &&
          this.res?.attribute?.comboConfigurationString != '""'
        ) {
          let comboString = this.res?.attribute?.comboConfigurationString;
          if (
            comboString &&
            JSON.stringify(comboString) != '{}' &&
            comboString != '""'
          ) {
            let tempComboConfigurationString = Object.assign({}, comboString);
            let flag = false;
            let comboStringVal = {};
            for (let key in tempComboConfigurationString) {
              let tempString: string = tempComboConfigurationString[key];
              tempString = Number(tempString)
                ? tempString.toString()
                : tempString;
              if (tempString.includes('ComponentId')) {
                let parentId = tempComboConfigurationString[key].split('_')[1];
                let fieldType = this.commonService.componentMap[parentId];
                let objValue = null;
                if (fieldType == 5) {
                  objValue = this.commonService.appGenFormGroup.controls[
                    parentId
                  ]?.value?.optionValue;
                } else {
                  objValue = this.commonService.appGenFormGroup.controls[
                    parentId
                  ]?.value;
                }
                comboStringVal[key] = objValue;
                flag = true;
              } else {
                comboStringVal[key] = tempString;
              }
            }

            if (comboStringVal && JSON.stringify(comboStringVal) != '{}') {
              // this.appGenServiceService
              //   .getComboIds(comboVal.toString(), comboStringVal)
              //   .subscribe((response: any) => {
              //     this.res.attribute.comboData = response;
              //     if (this.res?.attribute?.defaultValue) {
              //       this.setMultiSelectData(this.res);
              //     }
              //   });
              this.res.attribute.comboData = this.res.attribute.comboMapValues;
              if (this.res?.attribute?.defaultValue) {
                this.setMultiSelectData(this.res);
              }
            }
          } else {
            // this.appGenServiceService
            //   .getComboIds(comboVal.toString())
            //   .subscribe((response: any) => {
            //     this.res.attribute.comboData = response;
            //     if (this.res?.attribute?.defaultValue) {
            //       this.setMultiSelectData(this.res);
            //     }
            //   });
            this.res.attribute.comboData = this.res.attribute.comboMapValues;
            if (this.res?.attribute?.defaultValue) {
              this.setMultiSelectData(this.res);
            }
          }
        }
      }
    }
    if (this.res.fieldType == 99) {
      this.res?.cmnFormFieldEventList?.forEach((event) => {
        event.cmnEventExecutionList?.forEach((exe) => {
          if (exe.executionType == 533312) {
            this.buttonSubmit = true;
          }
        });
      });
    }
    if (this.res.fieldType == 25) {
      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ]?.valueChanges.subscribe((data) => {
        //if condition reset -> make reset key
        // typescript -> reset form group k andr
        if (data == 'reset') {
          this.appgenFileUpload.deleteAttachment(
            this.appgenFileUpload.files[0]
          );
        }
        this.attachData = data;
      });
    }
    this.appGenDataEmit.emit(this.appGenServiceService.appGenData);
  }

  updateRows = (fieldId) => {
    if (this.roAr[fieldId]) {
      this.roAr[fieldId] = [...this.roAr[fieldId]];
      let rowData = [...this.roAr[fieldId]];
      if (this.addRowDelete[fieldId]?.length > 0) {
        rowData = [...this.roAr[fieldId], ...this.addRowDelete[fieldId]];

        //merge current delete json into rowdata
        if (this.deleteDataWithoutId) {
          this.currentDeleteJson;
          rowData = [...rowData, ...this.currentDeleteJson];
        }
      }
      let hideColumnName;
      Object.keys(this.res.children).forEach((key) => {
        if (this.res.children[key]?.attribute.hideShow) {
          hideColumnName = this.res.children[key]?.children[0].id;
        }
      });
      let rowFieldId;
      if (hideColumnName != null && hideColumnName != undefined) {
        rowFieldId = this.columnData.filter(
          (data) => data.columnId == hideColumnName
        )[0].fieldId;
      }
      rowData?.forEach((rowDataEle, index) => {
        for (const key in rowDataEle) {
          if (Object.prototype.hasOwnProperty.call(rowDataEle, key)) {
            let checkIndex = this.colAr[fieldId].findIndex(
              (x) => x?.columnId?.toString() == key?.toString() && x?.type == 0
            );
            if (checkIndex != -1) {
              const element = rowDataEle[key];
              rowDataEle[key] = this.datePipe.transform(
                new Date(element),
                'yyyy-MM-dd'
              );
            }
          }
        }

        // add id of hidecolumn at add operation for set the value in datatable component
        if (rowDataEle[hideColumnName] == '') {
          if (this.masterCount == 1) {
            if (rowDataEle.operation != 'delete') {
              rowDataEle.operation = 'update';
            }
          }
          if (this.execution.checkSubmitResponse != undefined) {
            if (
              index + 1 <=
              this.execution.checkSubmitResponse[this.dataTableFieldId]?.length
            ) {
              let pk_Id = this.execution.checkSubmitResponse[
                this.dataTableFieldId
              ][index][rowFieldId];
              rowDataEle[hideColumnName] = pk_Id;
            }
          }
          //for delete current row
          if (rowDataEle.operation == 'delete') {
            let lengthID =
              this.execution.checkSubmitResponse[this.dataTableFieldId]
                ?.length - 1;
            let pk_Id = this.execution.checkSubmitResponse[
              this.dataTableFieldId
            ][lengthID][rowFieldId];
            rowDataEle[hideColumnName] = pk_Id;
            rowDataEle[rowFieldId] = pk_Id;
          }
        }
        // Skip to modified the add operation if Hyper Link available in row
        let hyperLink;
        Object.keys(rowDataEle).forEach((data) => {
          if (!isNaN(parseInt(data))) {
            let compType = this.commonService.isComponentType(this.res, data);
            if (compType == 23) {
              hyperLink = compType;
            }
          }
        });

        if (hyperLink != 23) {
          if (rowDataEle.operation == 'add') {
            rowDataEle[hideColumnName] = '';
          }
        }

        /* if (rowDataEle.operation == 'add') {
          rowDataEle[hideColumnName] = '';
        } */
      });

      if (rowData?.length > 0)
        this.appGenServiceService.setAppGenData(
          fieldId,
          //this.roAr[fieldId],
          rowData,
          this.colAr[fieldId]
        );
    }
    this.masterCount = this.masterCount + 1;
  };
  masterUpdate() {
    this.masterCount = 1;
  }

  setMultiSelectData(data) {
    let defaulValueArray = [];
    let defaultVal = data?.attribute?.defaultValue;

    if (defaultVal.optionValue) {
      defaultVal = defaultVal.optionValue;
    } else {
      defaultVal = data?.attribute?.defaultValue;
    }
    this.res.attribute.MultiselectValue = defaultVal?.split(',');
    let comboMapValues = data.attribute?.comboData;
    defaultVal?.split(',')?.forEach(function (defaultValueObj) {
      if (defaultValueObj && Number(defaultValueObj)) {
        defaulValueArray.push(
          comboMapValues?.find((o) => o.optionValue === defaultValueObj)
        );
      }
    });
    if (
      defaulValueArray &&
      Array.isArray(defaulValueArray) &&
      defaulValueArray.length != 0
    ) {
      this.appGenServiceService.setAppGenData(data.fieldId, defaulValueArray);
      data.cmnFormFieldEventList?.forEach((event) => {
        this.execution.executeEventService(
          event.cmnEventExecutionList,
          this.commonService.appGenFormGroup,
          data,
          this.formId,
          this.tid,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
      });
    }
  }
  setSubFieldData() {
    this.res?.children[0].subFldDataList?.forEach((element) => {
      Object.keys(element).forEach((key) => {
        if (this.comboColumns.includes(key)) {
          this.colAr[this.res.fieldId].forEach((obj) => {
            if (obj?.columnId == key) {
              element[key] = obj?.comboItems?.filter(
                (com) => com.optionValue == element[key]
              )[0];
            }
          });
        }
        this.colAr[this.res.fieldId].forEach((obj) => {
          if (obj.fieldType == 23) {
            element[obj.columnId] = obj.columnName;
          }
        });
        let checkIndex = this.columnData.findIndex(
          (x) => x?.columnId?.toString() == key?.toString() && x?.type == 0
        );

        if (checkIndex != -1) {
          const tempDate = element[key];
          element[key] = this.datePipe.transform(
            new Date(tempDate),
            'yyyy-MM-dd'
          );
        }
      });
      element.operation = 'update';
    });
    this.roAr[this.res.fieldId] = this.res.children[0].subFldDataList ?? [];
    this.roAr[this.res.fieldId].map((x) => {
      x.uniqueKey = uuidv4();
    });
    if (this.roAr[this.res.fieldId]?.length > 0)
      this.appGenServiceService.setAppGenData(
        this.res.fieldId,
        //this.roAr[fieldId],
        this.roAr[this.res.fieldId],
        this.colAr[this.res.fieldId]
      );
    let data;
    this.colAr[this.res.fieldId]?.forEach((res) => {
      if (res?.attribute?.fieldType == 23) {
        data = res;
      }
    });
    if (data) {
      let tempArrForPlMap = this.colAr[this.res.fieldId].filter(
        (res) => res.fieldId == data?.attribute?.dpdntPLMapCmpnt
      );
      tempArrForPlMap?.forEach((res) => {
        let fieldId = this.res.fieldId;
        this.execution.plmapColData.push(res);
      });
    }
  }
  checkDisable() {
    // code for save as draft event without manadatory save

    let saveDraftButton = false;
    if (this.res.cmnFormFieldEventList != undefined) {
      this.res.cmnFormFieldEventList[0].cmnEventExecutionList.forEach(
        (element) => {
          if (element.json.saveAsDraft) {
            saveDraftButton = element.json.saveAsDraft;
          }
        }
      );
    }

    let isStatus =
      this.res?.attribute?.enableDisable ||
      this.res?.attribute?.enableDisable ||
      (!this.commonService.appGenFormGroup.valid &&
        this.buttonSubmit &&
        !saveDraftButton);

    if (isStatus) {
      this.invalidObj = '';
      this.findInvalidControls();
      return isStatus;
    }
    return false;
  }
  invalidObj: any = '';
  findInvalidControls() {
    this.invalidObj = 'Please fill following mandatory fields \n';
    const controls = this.commonService.appGenFormGroup.controls;
    let count = 1;
    for (const name in controls) {
      if (controls[name].invalid) {
        this.invalidObj =
          this.invalidObj +
          count +
          '. ' +
          this.commonService.isLabelName[name] +
          '  \n';
        count = count + 1;
      }
    }
    return this.invalidObj;
  }
  checkDuplicateWholeRow(hideColumnName, fieldId, row) {
    let newrows = this.roAr[fieldId]?.find((item) => {
      let rowItem = { ...item };
      delete rowItem['_dynamicRowIndex'];
      delete rowItem[hideColumnName];
      delete rowItem['mobileViewExpanded'];
      delete rowItem['operation'];
      delete rowItem['rowIndex'];
      delete rowItem['actions'];
      delete rowItem['selected'];
      delete rowItem['uniqueKey'];
      Object.keys(rowItem).forEach((key1: any) => {
        try {
          let numberKey = Number(key1);
          if (numberKey) {
            delete rowItem[key1];
          }
          let isDate = rowItem[key1]?.getMonth();
          if (isDate) {
            rowItem[key1] = formatDate(rowItem[key1], 'yyyy-MM-dd', 'en-US');
          }
        } catch (e) {}
      });
      let rowItemNew = { ...row };
      delete rowItemNew['uniqueKey'];
      delete rowItemNew['actions'];
      delete rowItemNew[hideColumnName];
      delete rowItemNew['mobileViewExpanded'];
      delete rowItemNew['operation'];
      delete rowItemNew['rowIndex'];
      delete rowItemNew['selected'];
      Object.keys(rowItemNew).forEach((key1: any) => {
        try {
          let numberKey = Number(key1);
          if (numberKey) {
            //rowItemNew[key1] = numberKey.toString();
            delete rowItemNew[key1];
          }
          let isDate = rowItemNew[key1]?.getMonth();
          if (isDate) {
            rowItemNew[key1] = formatDate(
              rowItemNew[key1],
              'yyyy-MM-dd',
              'en-US'
            );
          }
        } catch (e) {}
      });
      delete rowItemNew['_dynamicRowIndex'];
      /* Object.keys(rowItem).forEach((rowKeys) => {
        let columnCheck = this.res?.children?.filter(
          (colField) => colField?.children[0]?.id == rowKeys
        );
        if (columnCheck[0].attribute.checkDuplicate) {
          if (rowItemNew[rowKeys] == rowItem[rowKeys]) {
            return false;
          } else {
            return true;
          }
        }
      }); */
      return JSON.stringify(rowItemNew) == JSON.stringify(rowItem);
    });
    return newrows;
  }
  checkDuplicateRow(hideColumnName, fieldId, row, action?, index?) {
    let deepRoAr;
    if (action && action == 'update') {
      deepRoAr = JSON.parse(JSON.stringify(this.roAr[fieldId]));
      deepRoAr.splice(index, 1);
    } else {
      deepRoAr = JSON.parse(JSON.stringify(this.roAr[fieldId]));
    }
    let columnCheck = this.res?.children?.filter(
      (colField) => colField?.attribute?.checkDuplicate
    );
    if (columnCheck && columnCheck?.length != 0) {
      let newrows = deepRoAr?.find((item) => {
        let rowItem = { ...item };
        delete rowItem['_dynamicRowIndex'];
        delete rowItem[hideColumnName];
        delete rowItem['mobileViewExpanded'];
        delete rowItem['operation'];
        delete rowItem['rowIndex'];
        delete rowItem['actions'];
        delete rowItem['selected'];
        delete rowItem['uniqueKey'];
        Object.keys(rowItem).forEach((key1: any) => {
          try {
            let numberKey = Number(key1);
            if (numberKey) {
              delete rowItem[key1];
            }
            let isDate = rowItem[key1]?.getMonth();
            if (isDate) {
              rowItem[key1] = formatDate(rowItem[key1], 'yyyy-MM-dd', 'en-US');
            }
          } catch (e) {}
        });
        Object.keys(rowItem).forEach((key1: any) => {
          columnCheck?.forEach((colC) => {
            if (colC?.children[0]?.id != key1) {
              delete rowItem[key1];
            }
          });
        });
        let rowItemNew = { ...row };
        delete rowItemNew['uniqueKey'];
        delete rowItemNew['actions'];
        delete rowItemNew[hideColumnName];
        delete rowItemNew['mobileViewExpanded'];
        delete rowItemNew['operation'];
        delete rowItemNew['rowIndex'];
        delete rowItemNew['selected'];
        Object.keys(rowItemNew).forEach((key1: any) => {
          try {
            let numberKey = Number(key1);
            if (numberKey) {
              //rowItemNew[key1] = numberKey.toString();
              delete rowItemNew[key1];
            }
            let isDate = rowItemNew[key1]?.getMonth();
            if (isDate) {
              rowItemNew[key1] = formatDate(
                rowItemNew[key1],
                'yyyy-MM-dd',
                'en-US'
              );
            }
          } catch (e) {}
        });
        Object.keys(rowItemNew).forEach((key1: any) => {
          columnCheck?.forEach((colC) => {
            if (colC?.children[0]?.id != key1) {
              delete rowItemNew[key1];
            }
          });
        });
        delete rowItemNew['_dynamicRowIndex'];
        return JSON.stringify(rowItemNew) == JSON.stringify(rowItem);
      });
      return newrows;
    }
  }
  onActionPerformed({ rowIndex, action, data, notifier, row }, fieldId) {
    this.eventExecution('dygridAction', this.res);
    //this.pk = this.prKey[fieldId]

    let notify: Notify;
    switch (action) {
      case 'create':
        //console.log('create obj Add Row Dataa', this.roAr[fieldId][rowIndex]);
        // console.log("rowww.....",row);

        // console.log('primary key', this.pk);
        row.uniqueKey = uuidv4();
        row.operation = 'add';
        let newrows = false;

        if (this.roAr?.[fieldId]?.length) {
          let hideColumnName;
          Object.keys(this.res.children).forEach((key) => {
            if (this.res.children[key]?.attribute.hideShow) {
              hideColumnName = this.res.children[key]?.children[0].id;
            }
          });
          let newWholeRow;
          this.res?.attribute?.checkDuplicate
            ? (newWholeRow = this.checkDuplicateWholeRow(
                hideColumnName,
                fieldId,
                row
              ))
            : (newWholeRow = false);
          newrows = this.checkDuplicateRow(hideColumnName, fieldId, row);

          if (!newWholeRow && !newrows) {
            let maxRowCount = this.res?.attribute?.maximumRowCount;
            if (maxRowCount && this.roAr?.[fieldId].length == maxRowCount) {
              this.msgDsplyService.errorToast({
                errors: [{ message: 'You can not add more row.' }],
              });
            } else {
              this.roAr[fieldId] = [...this.roAr[fieldId], row];
            }
          } else {
            this.msgDsplyService.errorToast({
              errors: [{ message: 'You can not add same row in table.' }],
            });
          }
        } else {
          this.roAr[fieldId] = [row];
        }
        if (!newrows || !this.res?.attribute?.checkDuplicate) {
          notify = { status: 1, data: { row } };
          notifier?.next(notify);

          this.updateRows(fieldId);
        }
        break;

      case 'update':
        //let pk= row[fieldId][uniquekey]
        row.operation = 'update';
        let index = this.roAr[fieldId]?.findIndex(
          (r) => r.uniqueKey?.toString() && r.uniqueKey === row.uniqueKey
        );
        let newrows2 = false;
        if (this.roAr?.[fieldId]?.length) {
          let hideColumnName;
          Object.keys(this.res.children).forEach((key) => {
            if (this.res.children[key]?.attribute.hideShow) {
              hideColumnName = this.res.children[key]?.children[0].id;
            }
          });
          newrows2 = this.checkDuplicateRow(
            hideColumnName,
            fieldId,
            row,
            action,
            index
          );
          if (!newrows2) {
            this.roAr[fieldId][index] = {
              ...this.roAr[fieldId][index],
              ...row,
            };
          } else {
            this.msgDsplyService.errorToast({
              errors: [{ message: 'You can not add same row in table.' }],
            });
          }
        } else {
          this.roAr[fieldId] = [row];
        }
        if (!newrows2) {
          notify = { status: 1, data: { row } };

          notifier?.next(notify);

          this.updateRows(fieldId);
        }
        // this.rows[rowIndex] = { ...this.rows[rowIndex], ...data };
        // this.updateRows(rowIndex);
        // console.log("upadte row  ", this.rows[index]);
        break;

      case 'delete':
        const dialogRef = this.dialog.open(SampleDialogComponent, {
          width: '250px',
          data: { message: 'Do you want to delete?' },
        });

        dialogRef.afterClosed().subscribe((result) => {
          row.operation = 'delete';
          // if (row.operation != 'add') {
          row.fieldIdTemp = fieldId;

          let tempArrForPkColumn = this.colAr[this.res.fieldId].filter(
            (res) => res?.attribute?.hideShow == true
          );
          console.log(tempArrForPkColumn);

          if (row[tempArrForPkColumn[0]?.fieldId]?.length != 0) {
            if (this.addRowDeleteArray[fieldId]?.length) {
              this.addRowDeleteArray[fieldId].push(row);
            } else {
              this.addRowDeleteArray[fieldId] = [row];
            }
          } else {
            this.currentDeleteJson = [row];
            this.deleteDataWithoutId = true;
          }

          this.addRowDelete = this.addRowDeleteArray;

          if (result) {
            this.roAr[fieldId] = this.roAr[fieldId]?.filter(
              (r) => r.uniqueKey?.toString() && r.uniqueKey !== row.uniqueKey
            );

            //  const deleteObj={
            //    delFieldId: fieldId,
            //    primaryKeyValue:this.roAr[fieldId][this.pk],
            //    subMappingId:this.subfieldMappingMap[this.pk]
            //  }

            notify = { status: 1, data: { row } };
            notifier?.next(notify);

            // this.appGenServiceService.setAppGenData(
            //   fieldId,
            //   this.addRowDelete[fieldId],
            //   this.colAr[fieldId]
            // );
            this.updateRows(fieldId);
          }
        });
        break;
      case 'add':

      default:
        break;
    }
  }

  sendLinkData(data, eventData, linkValue) {
    if (data?.children?.length > 0) {
      data?.children.forEach((element) => {
        this.sendLinkData(element, eventData, linkValue);
      });
    } else {
      if (data?.fieldType == 23 && data?.attribute?.label == linkValue) {
        let tempArr = this.colAr[this.res.fieldId].filter(
          (res) => res.fieldId == data?.attribute?.dependentCmpntId
        );
        let tempArrForPlMap = this.colAr[this.res.fieldId].filter((res) => {
          if (res.fieldId) {
            if (res.fieldId == Number(data?.attribute?.dpdntPLMapCmpnt)) {
              return res;
            }
          }
        });
        this.eventExecution(
          'onClick',
          data,
          eventData,
          tempArr[0].columnId,
          tempArrForPlMap[0]?.columnId
        );
      }
    }
  }
  onLinkClick(eventData: any) {
    eventData.row.rowIndex = eventData.rowIndex;

    let linkEventData = eventData?.col?.cmnFormFieldEventList;

    linkEventData.forEach((linkEventData) => {
      if (linkEventData.eventName == 'onClick') {
        console.log(linkEventData?.cmnEventExecutionList);
        this.sendLinkData(
          this.res,
          eventData?.row,
          eventData?.col?.defaultValue
        );
      }
    });

    this.commonService.dataTableRowData = eventData?.row;
  }
  onGridInputChange(eventData: any) {
    eventData.row.rowIndex = eventData.rowIndex;

    if (
      eventData?.data?.cmnFormFieldEventList &&
      eventData?.data?.cmnFormFieldEventList[0].eventName == 'onChange'
    ) {
      eventData?.data?.cmnFormFieldEventList?.forEach((event) => {
        let currentCompData = eventData?.formControlValue;
        this.execution.executeEventService(
          event.cmnEventExecutionList,
          eventData?.form,
          eventData?.data,
          this.formId,
          this.tid,
          null,
          null,
          null,
          null,
          currentCompData,
          null,
          null,
          null
        );
      });
    }
    this.commonService.dataTableRowData = eventData?.row;
  }

  getAddressOutput(event: any, fieldId: any): void {
    this.eventExecution('addressOutput', this.res);
    this.appGenServiceService.setAppGenData(fieldId, event);
    // this.addressData[fieldId] = event;

    // console.log('inside address function data----', this.addressData);
  }

  onNodeClick(value: any): void {
    // if (value?.editable) {
    //   this.selectedNode = value.id;
    //   this.child = value.children;
    // }
    let json = {
      fieldId: 29,
      value: value,
    };
    // this.onClick.emit(json);
  }

  onNodeSave(saveEvent: any, fieldId: any): void {
    const event = saveEvent?.currentNode;

    let saveUrl: string = this.nodeDataUrl[fieldId] + event?.parent?.id;
    this.http.get(saveUrl).subscribe((res: any) => {
      let temp = res?.data;
      temp = temp[0];
      if (temp?.orgName && temp?.orgShrtName) {
        let newOrgJson = {
          orgName: null,
          orgTypeId: 0,
          prntOrgId: 0,
        };
        newOrgJson.orgName = event?.name;
        newOrgJson.prntOrgId = event?.parent?.id;
        if (event?.parent) {
          newOrgJson.orgTypeId = 14;
        } else {
          newOrgJson.orgTypeId = 12;
        }

        let insertUrl: string = this.nodeInsertUrl[fieldId];
        this.http.post(insertUrl, newOrgJson).subscribe(
          () => {
            // this.getTreeData();
            window.scroll(0, 0);
          },
          (err) => {
            console.error('Insert Time Error', err);
          }
        );
      } else {
        this.msgDsplyService.errorToast({
          errors: [
            {
              message:
                'Please submit all the mandatory fields of Parent Organizaion First',
            },
          ],
        });
        // this.getTreeData();
        window.scroll(0, 0);
      }
    });
    //   let json={
    //     dgApptree: this.dgAppTreeJ[fieldId],
    //     fieldId:fieldId,
    //     saveEvent:saveEvent
    //   };
    //   this.onClick.emit(json);
  }

  getDataListBox(data: Event, fieldId: any): void {
    this.dgListBoxJ[fieldId] = data;
    // this.output = data;
  }
  onItemsClicked(val: unknown[], fieldId: any): void {
    console.log('listbox on click test component ', val);
  }

  getData2(data): void {}

  onFinalPath(finalPath: Event, fieldId): void {
    //Will provide the finalPath for first component

    if (finalPath) {
      this.appGenServiceService.setAppGenData(fieldId, {
        attachId: this.res?.attribute?.attachId,
        path: finalPath,
      });

      this.commonService.formGroup[fieldId].setValue({
        attachId: this.res?.attribute?.attachId,
        path: finalPath,
      });
    } else if (this.res?.attribute?.attachId) {
      this.appGenServiceService.setAppGenData(this.res.fieldId, {
        attachId: this.res?.attribute?.attachId,
        path: finalPath,
      });

      this.commonService.formGroup[fieldId].setValue({
        attachId: this.res?.attribute?.attachId,
        path: finalPath,
      });
    } else {
      this.appGenServiceService.setAppGenData(this.res.fieldId, '');

      this.commonService.formGroup[fieldId].reset();
    }
    this.eventExecution('attachUpload', this.res);
  }

  getGridConfig(res): any {
    return res?.attribute?.gridConfig;
  }

  getData() {
    return this.roAr;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our data
    if (value) {
      this.res?.attribute?.dataList.push({ name: value });
    }

    // Clear the input value
    event.chipInput!.clear();
    this.eventExecution('add', this.res);
  }

  remove(data: any): void {
    const index = this.res?.attribute?.dataList.indexOf(data);

    if (index >= 0) {
      this.res?.attribute?.dataList.splice(index, 1);
    }
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    this.eventExecution('remove', this.res);

    return this.options.filter((option) =>
      option.optionText.toLowerCase().includes(filterValue)
    );
  }
  selectOption(e: any, fieldId) {
    this.appGenServiceService.setAppGenData(fieldId, e.option.value);
    this.eventExecution('selectOption', this.res);
  }

  onClick() {
    this.eventExecution('onClick', this.res);
  }
  onEditor(event: {
    editor: {
      document: {
        getBody(): {
          $: any;
        };
      };
    };
  }) {
    let data: any;
    if (event.editor.document.getBody().$.innerHTML != '<p><br></p>') {
      // data = btoa(event.editor.document.getBody().$.innerHTML);
      data = event.editor.document.getBody().$.innerHTML;
    } else {
      if (this.res?.attribute?.isMandatory == true) {
        this.commonService.appGenFormGroup.controls[
          this.res.fieldId
        ].setValidators([Validators.required]);
      }
    }
    this.appGenServiceService.setAppGenData(this.res.fieldId, data);
    this.commonService.appGenFormGroup.controls[this.res.fieldId]?.setValue(
      data
    );
    this.eventExecution('change', this.res);
  }

  eventExecution(
    eventName: string,
    jsonObject,
    rowData?,
    TransIdcolumn?,
    plMapColumnId?
  ) {
    jsonObject.cmnFormFieldEventList?.forEach((event) => {
      if (event.eventName == eventName) {
        this.execution.executeEventService(
          event.cmnEventExecutionList,
          this.commonService.appGenFormGroup,
          jsonObject,
          this.formId,
          this.tid,
          rowData,
          TransIdcolumn,
          this.addRowDelete,
          this.res,
          this.columnData,
          this.colAr,
          this.roAr,
          null,
          plMapColumnId
        );
        this.execution.notifyRefreshRows?.asObservable()?.subscribe((res) => {
          console.log(res);
          this.roAr[res?.fieldId] = res?.rowData;
          this.updateRows(this.res.fieldId);
        });
      }
    });
  }

  answerChange(event) {
    console.log('Answer changed');
  }

  onParentClick(data) {
    this.questionnaireData = data?.data;
  }
  convertToHtml(content) {
    //content is object iam converting to boolean
    if (!!content) {
      return this.sanitizer.bypassSecurityTrustHtml(content);
    } else {
      return '';
    }
  }
  onSaveClick(data) {
    console.log('on Save click', data);
  }

  onChangeDateTime(jsonObject, datetime) {
    this.appGenServiceService.setAppGenData(this.res.fieldId, datetime);
    this.commonService.appGenFormGroup.controls[this.res.fieldId].setValue(
      datetime
    );
    this.eventExecution('onChange', jsonObject);
    if (datetime !== null) {
      this.datePickerControl.clearValidators();
      this.datePickerControl.updateValueAndValidity();

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].clearValidators();

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].updateValueAndValidity();
    } else {
      this.datePickerControl.setValidators([Validators.required]);
      this.datePickerControl.updateValueAndValidity();

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].setValidators([Validators.required]);

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].updateValueAndValidity();
    }
  }

  onChangeTime(jsonObject, time) {
    this.appGenServiceService.setAppGenData(this.res.fieldId, time);

    this.eventExecution('onChange', jsonObject);

    if (time !== null) {
      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].clearValidators();

      this.commonService.appGenFormGroup.controls[
        this.res.fieldId
      ].updateValueAndValidity();
      this.commonService.appGenFormGroup.controls[this.res.fieldId].setValue(
        time
      );
    }
  }
  onChangeToggleButton(jsonObject, toggleButton) {
    this.appGenServiceService.setAppGenData(this.res.fieldId, toggleButton);
    jsonObject.cmnFormFieldEventList?.forEach((event) => {
      this.execution.executeEventService(
        event.cmnEventExecutionList,
        this.commonService.appGenFormGroup,
        jsonObject,
        this.formId,
        this.tid,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    });
  }

  onChangeSelect(jsonObject, comboData) {
    this.appGenServiceService.setAppGenData(this.res.fieldId, comboData);
    this.commonService.appGenFormGroup.controls[this.res.fieldId]?.setValue(
      comboData
    );
    jsonObject.cmnFormFieldEventList?.forEach((event) => {
      this.execution.executeEventService(
        event.cmnEventExecutionList,
        this.commonService.appGenFormGroup,
        jsonObject,
        this.formId,
        this.tid,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    });
  }

  onChangeToggle() {
    //  console.log(this.toggleValue);
    this.appGenServiceService.setAppGenData(this.res.fieldId, this.toggleValue);
  }

  getChckLstComponentData(customData) {
    // console.log(customData);
    this.customCompData.emit(customData);
    if (customData?.length != 0) {
      customData?.forEach((devFormData) => {
        if (devFormData?.from == 'appgenData') {
          /* this.execution.parentCommonService?.notifyParentCommonServiceSubject?.next({
            data:  this.appGenServiceService.getAppGenData(this.formId, this.tid),
            fieldId: this.res.fieldId,
            resultObj: this.commonService?.inputJsonData,
          }); */
          this.commonService.setAppGenTransFormData(devFormData?.data);
          this.appGenDataEmit.emit(this.appGenServiceService.appGenData);
        }
        if (devFormData?.from == 'hideDevForm') {
          if (this.res?.attribute?.fieldId == devFormData?.data?.fieldId) {
            this.displayDevForm[
              this.res?.attribute?.fieldId
            ] = this.res?.attribute?.hideShow;
            this.flagDeveloperForm = true;
          }
        }
      });
    }
  }

  public icon = 'asdfsahdfjksdhk';

  public changeIcon() {
    for (const field in this.commonService.appGenFormGroup.controls) {
      // 'field' is a string
      if (!this.commonService.appGenFormGroup.controls[field].valid)
        console.log(this.commonService.appGenFormGroup.controls[field].value);
      console.log(this.commonService.appGenFormGroup.controls[field].valid);
    }
  }

  checkDisplayDevForm(fieldId) {
    if (this.res?.attribute?.developerForm != 'Appgen form') {
      return !this.res?.attribute?.hideShow;
    }
    if (this.flagDeveloperForm) {
      this.displayDevForm[fieldId] = this.res?.attribute?.hideShow;
      return !this.displayDevForm[fieldId] || !this.res?.attribute?.hideShow;
    } else {
      return true;
    }
  }

  // employee search start

  onChangeEmp(jsonObject, e: Event): void {
    this.onChangeEmployee(e);

    // load -> id
    jsonObject.cmnFormFieldEventList?.forEach((event) => {
      this.execution.executeEventService(
        event.cmnEventExecutionList, // event call hota h transaction id set krata h
        this.commonService.appGenFormGroup, //common formgroup
        jsonObject,
        this.formId, //form id
        this.tid, //save hote time transaction
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    });
  }

  onChangeEmployee(empData: Event) {
    this.output.emit(empData);
    let emp_id;
    if (empData['EMP_ID']) {
      emp_id = empData['EMP_ID'];
      this.selectedEmployees = empData;
    } else {
      emp_id = empData[0]['EMP_ID'];
      this.selectedEmployees = empData[0];
    }

    // appgen form builder ka form group
    this.appGenServiceService.setAppGenData(this.res.fieldId, emp_id);
    this.commonService.appGenFormGroup.controls[this.res.fieldId]?.setValue(
      emp_id
    );

    this.showReadOnly = true;

    this.empName = this.selectedEmployees.FULL_NAME
      ? this.selectedEmployees.FULL_NAME
      : '';
    this.emplocation = this.selectedEmployees.ORG_NAME
      ? this.selectedEmployees.ORG_NAME
      : '';

    this.empdesignation = this.selectedEmployees.UNIT_NAME
      ? this.selectedEmployees.UNIT_NAME
      : '';

    this.empdistrict = this.selectedEmployees.USER_NAME
      ? this.selectedEmployees.USER_NAME
      : '';

    this.empgpf_number = this.selectedEmployees.EMP_ID
      ? this.selectedEmployees.EMP_ID
      : '';

    this.outputEmpID();
  }

  getDataEmp(val: Event): void {
    // console.log('data in emp-search test', val);
  }

  outputEmpID() {
    return this.empgpf_number;
  }

  getViewEmployee(id) {
    this.showReadOnly = true;

    this.http.get(`/admin/employee-details/${id}`).subscribe((res: any) => {
      // need to add in typescript

      const convertData = {
        FULL_NAME: res?.data.empFullName,

        ORG_NAME: res?.data.allUnitVO[0].organizationVOArr[0].organizationName,

        USER_NAME: res?.data.uniqueId,

        UNIT_NAME: res?.data.unitVO[0].unitName,

        EMP_ID: res?.data.empId,
      };

      this.onChangeEmployee({ ...res?.data, ...convertData });

      // console.log('emp search response', res?.data)
    });
  }

  // employee search end

  // Time start
  openFromIcon(timepicker: { open: () => void }) {
    timepicker.open();
  }
}
